import React from 'react';
import { IconProps } from './createIcon';
import {
  AudioFileIcon,
  ExcelFileIcon,
  FileAltIcon,
  FontFileIcon,
  ImageFileIcon,
  PDFFileIcon,
  PowerPointFileIocn,
  VideoFileIcon,
  WordFileIcon,
  ZIPFileIcon,
} from './default';
import { AppFileTypes, mimeTypeToAppType } from 'utils/file/MIMETypeUtils';

interface FileIconProps extends IconProps {
  mimeType?: string;
}

export const FileIcon = ({ mimeType, ...props }: FileIconProps) => {
  switch (mimeTypeToAppType(mimeType)) {
    case AppFileTypes.AUDIO:
      return <AudioFileIcon {...props} />;
    case AppFileTypes.VIDEO:
      return <VideoFileIcon {...props} />;
    case AppFileTypes.FONT:
      return <FontFileIcon {...props} />;
    case AppFileTypes.PDF_DOCUMENT:
      return <PDFFileIcon {...props} />;
    case AppFileTypes.IMAGE:
      return <ImageFileIcon {...props} />;
    case AppFileTypes.EXCEL_DOCUMENT:
      return <ExcelFileIcon {...props} />;
    case AppFileTypes.POWERPOINT_DOCUMENT:
      return <PowerPointFileIocn {...props} />;
    case AppFileTypes.WORD_DOCUMENT:
      return <WordFileIcon {...props} />;
    case AppFileTypes.ZIP:
      return <ZIPFileIcon {...props} />;
    default:
      return <FileAltIcon {...props} />;
  }
};
